import consumer from "./consumer"

export function subscribeLinkedinMessages(linkedin_chat_id, callback) {
  return consumer.subscriptions.create(
    { channel: "LinkedinMessagesChannel", linkedin_chat_id: linkedin_chat_id },
    {
      received(data) {
        callback(data)
      }
    }
  )
}
